'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUsers = exports.makeFilteredUsersResourcesSelector = exports.userResourcesSelector = undefined;

var _resourceSelector = require('../utils/services/http/resources/resourceSelector');

var userResourcesSelector = exports.userResourcesSelector = (0, _resourceSelector.makeResourceTypeSelector)('users'); // Utils
var makeFilteredUsersResourcesSelector = exports.makeFilteredUsersResourcesSelector = (0, _resourceSelector.makeFilteredResourcesSelector)('users');

var getUsers = exports.getUsers = function getUsers(state) {
    return state.get('users');
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/usersSelector.js
// module id = 204
// module chunks = 0